import request from "./request";

/************ 积分模块 ************/
// 获取会员积分
export const userPoints = (params) => {
  return request({
    url: `/points/userPoints/${params.userId}`,
    params,
  });
};
// 积分中心-用户积分任务查询
export const userPointsTask = (params) => {
  return request({
    url: "/points/userPointsTask",
    params,
  });
};
// 每日积分签到
export const daySign = (params) => {
  return request({
    url: "/points/daily/sign",
    params,
  });
};
// 会员积分明细list查询 (月份分组)
export const detailList = (params) => {
  return request({
    url: `/points/frontPointsDetail`,
    params,
  });
};
// 校验用户任务是否完成 taskType=1 是新手任务
export const validateUserPointsTask = (params) => {
  return request({
    url: `/points/validateUserPointsTask`,
    params,
  });
};

// 每日积分任务完成查询 type：1001-注册成功; 4000-每日累计学习时长; 5001-每日首次完成课程习题; 5002-每日首次发表留言
export const eventPoint = (params) => {
  return request({
    url: `/points/pull/eventPoint`,
    params,
  });
};

// 获取积分商城免密登录CODE
export const marketCode = (params) => {
  return request({
    url: `/market/code`,
    params,
  });
};

/************ 大会模块 ************/
// 大会内容-详情和内容
export const queryDetailAndContent = (params) => {
  return request({
    url: "/liveMeeting/detailsContent",
    params,
  });
};

// 大会内容-详情
export const queryDetail = (params) => {
  return request({
    url: "/liveMeetingRelation/detail",
    params,
  });
};

// 大会报名状态
export const getApplyStatus = (params) => {
  return request({
    url: "/liveMeeting/apply/getApplyStatus",
    params,
  });
};

// 提交大会订单
export const submitOrder = (data) => {
  return request({
    url: "/payment/order/meeting/submitOrder",
    data,
    method: "post",
  });
};

// 多报名提交大会订单
export const submitManyOrder = (data) => {
  return request({
    url: "/payment/order/meeting/submitOrderList",
    data,
    method: "post",
  });
};

// 大会报名-发起支付
export const meetPrepay = (data) => {
  return request({
    url: `payment/order/meeting/prepay/${data.id}`,
    data,
    method: "post",
  });
};

// 获取用户大会订单订单列表
export const getOrderList = (params) => {
  return request({
    url: "/payment/order/meeting/orderList",
    params,
  });
};

// 获取用户大会多报名订单订单列表
export const getManyOrderList = (params) => {
  return request({
    url: "/payment/order/meeting/orderListByMeetingId",
    params,
  });
};

// 取消订单
export const cancelOrder = (data) => {
  return request({
    url: `/payment/order/cancelOrder/${data.id}`,
    data,
    method: "post",
  });
};

// 发票表单
export const getInvoiceForm = (params) => {
  return request({
    url: "/form/template/getInvoiceForm",
    params,
  });
};

// 提交发票
export const submitInvoiceApply = (data) => {
  return request({
    url: `/payment/order/meeting/submitInvoiceApply`,
    data,
    method: "post",
  });
};

// 通用大会支付
export const commonMeetingPay = (id) => {
  return request({
    url: `/conference/user/home/apply/prepay/${id}`,
    method: "post",
  });
};

/************ 专项培训模块 ************/
// 根据培训流程id，查询用户各个步骤的详情
export const userProcessStep = (params) => {
  return request({
    url: `/userProcessStep/details`,
    method: "get",
    params,
  });
};
// 培训流程详情
export const queryDetails = (id) => {
  return request({
    url: `/specialTraining/queryDetails/${id}`,
    method: "get",
  });
};
// 根据培训流程步骤id，查询培训步骤的详情
export const queryContentDetails = (params) => {
  return request({
    url: `/processStepContent/queryContentDetails`,
    method: "get",
    params,
  });
};
// 获取培训图文
export const queryTuWen = (params) => {
  return request({
    url: `/special/list${params.id}`,
    method: "get",
    params,
  });
};
// 获取培训文件
export const queryWenJian = (data) => {
  return request({
    url: `contentController/queryPageByColumnId`,
    method: "post",
    data,
  });
};
// 订阅培训主题
export const subscribe = (data) => {
  return request({
    url: `/collection/subscribe`,
    method: "post",
    data,
  });
};
// 取消培训订阅主题
export const cancelSubscribe = (data) => {
  return request({
    url: `/collection/cancelSubscribe`,
    method: "post",
    data,
  });
};
// 获取培训外链
export const queryLink = (params) => {
  return request({
    url: `link/queryPage`,
    method: "get",
    params,
  });
};
// 培训ai课
export const fontCoursePage = (params) => {
  return request({
    url: `/tingwu/fontCoursePage`,
    method: "get",
    params,
  });
};

/************ 课程模块 ************/
// 根据流程步骤id，查询用户某个步骤的详情
export const queryPageByColumnId = (data) => {
  return request({
    url: `/contentController/queryPageByColumnId`,
    method: "post",
    data,
  });
};
export const getClassList = (params) => {
  return request({
    url: "/series/getSeriesCoursePage",
    method: "get",
    params,
  });
};
// 单个流程详情
export const processStepDetails = (params) => {
  return request({
    url: "/userProcessStep/processStepDetails",
    method: "get",
    params,
  });
};
// 根据一层id，获取所有的虚假二层图文
export const queryImageTextPageByColumnId = (data) => {
  return request({
    url: "/contentController/queryImageTextPageByColumnId",
    method: "post",
    data,
  });
};
// 学习中心专题list查询
export const studyColumnList = () => {
  return request({
    url: "/perTheme/studyColumnList",
  });
};
// 学习中心各主题下的所有课程列表(tag为内容标签/课程)
export const secColumnCourseList = (params) => {
  return request({
    url: "/special/secColumnCourseList",
    params,
  });
};
// 获取培训系统数据
export const getTrainData = (params) => {
  return request({
    url: "/data/getTrainData",
    params,
  });
};
// 用户时长统计
export const ranking = () => {
  return request({
    url: "/statistics/user/view/ranking",
  });
};
// 学员申请项目
export const applyProject = (params) => {
  return request({
    url: "/apply/project/student/add",
    params,
  });
};
// 认证详情
export const applyDetail = (params) => {
  return request({
    url: `/user/apply/student/detail`,
    params,
  });
};
// 获取习题
export const getExercise = (params) => {
  return request({
    url: `/exercise/user/exercise/${params.courseId}`,
    params,
  });
};
// 提交习题
export const exerciseCommit = (data) => {
  return request({
    url: "/exercise/user/exerciseCommit",
    data,
    method: "post",
  });
};
// 医0-学习中心-我的课程
export const myCourse = (params) => {
  return request({
    url: "/perTheme/getMyThemeColumnCourse",
    params,
    method: "get",
  });
};
// 医0-学习中心-我学习过的主题
export const historyStudyTheme = (params) => {
  return request({
    url: "/perTheme/userStudytheme",
    params,
    method: "get",
  });
};
// 医0-学习中心-今日时长-总时长
export const studyTime = (params) => {
  return request({
    url: "/special/user/getActualViewTime",
    params,
    method: "get",
    showLoading: true,
  });
};
// 二层列表
export const listAndBannerPage = (params) => {
  return request({
    url: `/special/listAndBannerPage/${params.id}`,
    params,
    method: "get",
  });
};
// 全部课程
export const getAllCourse = (data) => {
  return request({
    url: `/special/getAllCourse`,
    data,
    method: "post",
  });
};
// 一级：疾病字典
export const treeTagList = (params) => {
  return request({
    url: `/tag/treeTagList?level=1&tagName=疾病标签`,
    params,
    method: "get",
  });
};
// 我的课程-筛选
export const getMyCourseTagList = (data) => {
  return request({
    url: `/special/getMyCourseTagList`,
    data,
    method: "post",
  });
};
// 我的课程
export const getMyCourse = (data) => {
  return request({
    url: `/special/getMyCourse`,
    data,
    method: "post",
  });
};
export const getCurseDetail = (id) => {
  return request({
    url: `/tingwu/courseFileDetail/${id}`,
  });
};

//PC视解析页面
export const getcourseDetailbyId = (params) => {
  return request({
    url: `/tingwu/frontCourseDetail/${params.id}`,
    method: "get",
    params,
  });
};

/************ 试卷模块 ************/
// 获取试卷信息
export const examDetail = (params) => {
  return request({
    url: `/exam/user/detail/${params.examId}`,
    method: "get",
  });
};
// 根据考试id获取考试试卷
export const getPaperByExamId = (params) => {
  return request({
    url: `/exam/user/getPaperByExamId`,
    params,
    method: "get",
  });
};
// 处理考试结果
export const dealExaminationPaper = (data) => {
  return request({
    url: `/exam/user/dealExaminationPaper`,
    data,
    method: "post",
  });
};

// 获取当天考试次数
export const getExamCount = (params) => {
  return request({
    url: `/exam/user/queryTodayExamCount`,
    params,
    method: "get",
  });
};

/************ 问卷模块 ************/
// 问卷查询
export const getNewQuestion = (params) => {
  return request({
    url: "/question/questionStudent/getNewQuestion",
    params,
  });
};
// 提交问卷
export const questionCommit = (data) => {
  return request({
    url: "/question/questionStudent/questionCommit",
    method: "post",
    data,
  });
};

/************ 患教模块 ************/
// 用户-患教详情
export const patientEducationDetail = (params) => {
  return request({
    url: "/patientEducation/user/detail",
    method: "get",
    params,
  });
};
// 用户-获取同来源的患教列表-取前两个
export const getHomologyPEList = (params) => {
  return request({
    url: "/patientEducation/user/getHomologyPEList",
    method: "get",
    params,
  });
};
// 记录生成海报用户
export const setUserViewsRecords = (data) => {
  return request({
    url: "/user/addPageBrowserRecord",
    method: "post",
    data,
  });
};

/************ 认证模块 ************/
export const getProjectList = () => {
  return request({
    url: "/program/list",
  });
};
export const getUserStatus = (params) => {
  return request({
    url: "/user/student/getStatus",
    params,
  });
};
// 申请儿科并提交申请的表单信息
export const applyMhlpWithForm = (data) => {
  return request({
    url: "/user/student/apply/update",
    method: "post",
    data,
  });
};
// 是否已经是儿科学员
export const isMhlpStudent = (params) => {
  return request({
    url: "/weChat/public/mhlp/getToken",
    method: "get",
    params,
  });
};

/**
 *
 * @param {查询公司名称(模糊查询)} name
 * @returns 公司名称，税号，开户行，联系人
 */
export const getTaitouInfo = (name) => {
  return request({
    url: "/invoice/getAllShuihaoByName",
    method: "get",
    params: {
      companyName: name,
    },
  });
};

/************ 分享模块 ************/
export const getWechatConfig = (params) => {
  return request({
    url: "/weChat/noncestr/timestamp/bySource",
    params,
  });
};

// 分享获取积分
export const getShareIntegral = () => {
  return request({
    url: "/points/share",
  });
};

/************ 病例模块 ************/
// 病例列表
export const getQueryUserPage = (data) => {
  return request({
    url: "/caseManage/queryUserPage",
    method: "post",
    data,
  });
};

// 病例列表 模糊查询
export const queryFuzzyUserPage = (data) => {
  return request({
    url: "/caseManage/queryFuzzyUserPage",
    method: "post",
    data,
  });
};

// 病例管理---详情
export const queryCaseDetails = (params) => {
  return request({
    url: `/caseManage/queryDetails/${params.id}`,
    params,
  });
};

// 停留时长用这个
export const setUserPageStayTime = (data) => {
  return request({
    url: `/special/user/setUserCasePageStayTime`,
    method: "post",
    data,
  });
};

// 获取绑定课程
export const getBindCourseList = (params) => {
  return request({
    url: `/caseManage/getBindCourseList`,
    params,
  });
};

// 热搜
export const getTagListByName = (params) => {
  return request({
    url: `/tag/getTagListByName`,
    params,
  });
};

export const departmentList = (params) => {
  return request({
    url: `/department/list`,
    params,
  });
};

export const departmentCaseList = (params) => {
  return request({
    url: `/department/case/list`,
    params,
  });
};

export const getPilotConfig = (params) => {
  return request({
    url: `/question/config/bySource`,
    params,
  });
};

export const getPilotDetail = (params) => {
  return request({
    url: `/specialTraining/queryDetails/open/${params.id}`,
    params,
  });
};

export const getPilotZTdetail = (params) => {
  return request({
    url: `/userProcessStep/processStepAndContent/details`,
    params,
  });
};

export const getByRelationId = (params) => {
  return request({
    url: `/form/content/getByRelationId`,
    params,
  });
};

export const getxxDetail = (params) => {
  return request({
    url: `/middle/normal/course/user/detail`,
    params,
  });
};
